import React from 'react'
import Footer from '../Footer'
import Uml6 from '../Uml6'

function Umass6() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml6/>
            <Footer/>
        </div>
    )
}

export default Umass6
